import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { AuthGuard } from '@nx-ratenow/core/guards';
import { CoreI18nModule } from '@nx-ratenow/core/i18n';
import { UiCustomLayoutComponent } from '@nx-ratenow/core/layout/feature-custom-layout';
import { getUserLoggedResolver } from '@nx-ratenow/shared/resolvers';

const routes: Routes = [
  {
    path: 'auth',
    loadChildren: () => import('@nx-ratenow/core/feature-auth').then((m) => m.CoreFeatureAuthModule)
  },
  {
    path: 'errors',
    loadChildren: () => import('@nx-ratenow/core/errors/feature-error-pages').then((m) => m.CoreErrorsFeatureErrorPagesModule)
  },
  {
    path: '',
    component: UiCustomLayoutComponent,
    canActivate: [AuthGuard],
    resolve: { userLoggedInfo: getUserLoggedResolver },
    children: [
      {
        path: 'dashboard',
        loadChildren: () => import('@nx-ratenow/dashboard/main').then((module) => module.DashboardMainModule)
      },
      {
        path: 'management-anaylitcs',
        loadChildren: () => import('@nx-ratenow/management-anaylitcs/main').then((module) => module.ManagementAnaylitcsMainModule)
      },
      {
        path: 'system-status',
        loadChildren: () => import('@nx-ratenow/system-status/main').then((module) => module.SystemStatusMainModule)
      },
      {
        path: 'providers',
        loadChildren: () => import('@nx-ratenow/providers/main').then((module) => module.ProvidersMainModule)
      },
      {
        path: 'system-config',
        loadChildren: () => import('@nx-ratenow/system-config/main').then((module) => module.SystemConfigMainModule)
      },
      {
        path: 'account-settings',
        loadChildren: () => import('@nx-ratenow/account-settings/main').then((module) => module.AccountSettingsMainModule)
      },
      {
        path: 'documentation',
        loadChildren: () => import('@nx-ratenow/documentation/main').then((module) => module.DocumentationMainModule)
      },
      {
        path: 'tools',
        loadChildren: () => import('@nx-ratenow/tools/main').then((module) => module.ToolsMainModule)
      },
      {
        path: '',
        redirectTo: 'dashboard',
        pathMatch: 'full'
      }
    ]
  },
  {
    path: '**',
    redirectTo: '/errors/404'
  }
];

@NgModule({
  imports: [
    CoreI18nModule,
    RouterModule.forRoot(routes, {
      scrollPositionRestoration: 'enabled',
      anchorScrolling: 'enabled',
      initialNavigation: 'enabledBlocking',
      paramsInheritanceStrategy: 'always',
      bindToComponentInputs: true
    })
  ],
  exports: [TranslateModule, RouterModule]
})
export class AppRoutingModule {}
